import { ETHEREUM_TEST_CONFIG } from "./chains/ethereum.js";
import { POLYGON_TEST_CONFIG } from "./chains/polygon.js";
import { BSC_TEST_CONFIG } from "./chains/bsc.js";
import { OPTIMISM_TEST_CONFIG } from "./chains/optimism.js";
import { BASE_TEST_CONFIG } from "./chains/base.js";
import { AVALANCHE_TEST_CONFIG } from "./chains/avalanche.js";
import { ARBITRUM_TEST_CONFIG } from "./chains/arbitrum.js";
import { GNOSIS_TEST_CONFIG } from "./chains/gnosis.js";
import { BERACHAIN_TEST_CONFIG } from "./chains/berachain.js";
import { MOONBEAM_TEST_CONFIG } from "./chains/moonbeam.js";
import { MONAD_TEST_CONFIG } from "./chains/monad.js";
import { LINEA_TEST_CONFIG } from "./chains/linea.js";
import { HYPERLIQUID_TEST_CONFIG } from "./chains/hyperliquid.js";
import { SCROLL_TEST_CONFIG } from "./chains/scroll.js";
import { PLASMA_TEST_CONFIG } from "./chains/plasma.js";
import { XLAYER_TEST_CONFIG } from "./chains/xlayer.js";
import { SOLANA_TEST_CONFIG } from "./chains/solana.js";
import { BITCOIN_TEST_CONFIG } from "./chains/bitcoin.js";
import { STARKNET_TEST_CONFIG } from "./chains/starknet.js";
/** Canonical per-chain matrix used to derive endpoint-specific test vectors. */
export const CORE_CHAIN_TEST_MATRIX = {
    ethereum: ETHEREUM_TEST_CONFIG,
    polygon: POLYGON_TEST_CONFIG,
    bsc: BSC_TEST_CONFIG,
    optimism: OPTIMISM_TEST_CONFIG,
    base: BASE_TEST_CONFIG,
    avalanche: AVALANCHE_TEST_CONFIG,
    arbitrum: ARBITRUM_TEST_CONFIG,
    gnosis: GNOSIS_TEST_CONFIG,
    berachain: BERACHAIN_TEST_CONFIG,
    moonbeam: MOONBEAM_TEST_CONFIG,
    monad: MONAD_TEST_CONFIG,
    linea: LINEA_TEST_CONFIG,
    hyperliquid: HYPERLIQUID_TEST_CONFIG,
    scroll: SCROLL_TEST_CONFIG,
    plasma: PLASMA_TEST_CONFIG,
    xlayer: XLAYER_TEST_CONFIG,
    solana: SOLANA_TEST_CONFIG,
    bitcoin: BITCOIN_TEST_CONFIG,
    starknet: STARKNET_TEST_CONFIG,
};
export const CORE_CHAIN_TEST_ENTRIES = Object.entries(CORE_CHAIN_TEST_MATRIX);
